export const inputtext = {
  root: {
    borderColor: 'rgb(226, 232, 240)',
    borderRadius: '1rem',
    color: 'rgb(31, 41, 55)',
    paddingX: '0.875rem',
    paddingY: '0.875rem',
    shadow: '0',
  },
  css: ({ dt }: any) => `
    @media (max-width: 600px) {
      .p-inputtext {
        letter-spacing: -0.025em;
      }
    }
  `,
};
